<pbc-filter-preset
  [filter]="formulare.preset$ | async"
  [filters]="formulare.presets$ | async"
  [name]="formulare.search$ | async"
  (select)="formulare.setFilter($event)"
  (save)="formulare.writeFilter($event)"
  (delete)="formulare.deleteFilter($event)"
></pbc-filter-preset>
